import { BASE_URL } from '../constants'

export const recordAnalytics_SublayerToggles = async (sublayerId, turnedOn) => {
  return fetch(`${BASE_URL}api/analytics/sublayerToggle`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sublayerId,
        turnedOn
      })
    })
}